import { Chip, formatCurrency, PreviewPriceGroup, TimeDurationFormatter } from '@utriper/core-ui';
import { getTranslatedName, moods } from '@utriper/core';
import { Grid2, styled, Typography } from '@mui/material';
import { Check, Close } from '@mui/icons-material';
import { PreviewService } from 'core/api/services/preview';
import { useTranslation } from 'react-i18next';

export const SectionTitle = styled(Typography)({
    fontSize: '18px',
    fontWeight: 600,
    color: '#131313',
});

export const Text = styled(Typography)({
    fontSize: '16px',
    color: '#131313',
    whiteSpace: 'break-spaces',
});

export const Container = ({ children }) => {
    return (
        <Grid2 container size={12} spacing={1} direction="column">
            {children}
        </Grid2>
    );
};

export const InfoSection = ({ title, children, hide = false }) => {
    return (
        <Grid2 display={{ xs: 'block', md: hide ? 'none' : 'block', width: '100%' }}>
            <Container>
                <SectionTitle noWrap>{title}</SectionTitle>
                {children}
            </Container>
        </Grid2>
    );
};

export const TextCheck = ({ checked = true, label = '' }) => {
    return (
        <Grid2 container size={12} spacing={1} alignItems="center">
            {checked ? <Check sx={{ color: '#50C878' }} /> : <Close sx={{ color: '#C51313' }} />}
            <Text>{label}</Text>
        </Grid2>
    );
};

export const Moduses = ({ moduses = [], language }) => {
    return (
        <InfoSection title="Moods">
            <Grid2 container size={12} direction="row" justifyContent="flex-start" alignItems="flex-start" gap="8px">
                {moduses.map((modus) => {
                    const label = getTranslatedName(moods, modus, language);
                    return (
                        <Chip
                            key={modus}
                            label={label}
                            sx={{
                                backgroundColor: '#131313',
                                color: '#fff',
                                padding: '16px 8px !important',
                                fontSize: '14px',
                                fontWeight: 500,
                                // opacity: isExiting ? 0 : 1,
                                // transition: 'opacity 300ms ease-in-out',
                            }}
                            // deleteIcon={<Clear sx={{ color: '#fff !important' }} />}
                            // onDelete={origins?.length > 1 ? () => handleDeleteOrigin(priceGroupId, origin, label) : null}
                        />
                    );
                })}
                {/* {getMoodsIds().length > experience?.moduses?.length && ( TODO: Check if it's really necessary
                                    <Chip
                                        label="Agregar Mood"
                                        sx={{
                                            backgroundColor: 'var(--color-utriper-blue)',
                                            color: '#fff',
                                            padding: '16px 8px !important',
                                            fontSize: '14px',
                                            fontWeight: 500,
                                            transition: 'background-color 0.2s ease-in-out',
                                            '&:hover': {
                                                backgroundColor: 'var(--color-utriper-blue-dark)',
                                            },
                                        }}
                                        icon={<Add sx={{ color: '#fff !important' }} />}
                                        //onClick={handleOpenOriginsForm}
                                    />
                )} */}
            </Grid2>
        </InfoSection>
    );
};

export const PriceDuration = ({ price, priceGroupId, duration, currency }) => {
    const { t: translate, i18n } = useTranslation();

    return (
        <Grid2 container size={12} spacing={1} justifyContent="flex-start" alignItems="center">
            {/* Price */}
            {(Number.isFinite(price) || priceGroupId) && (
                <Grid2 container size={6} spacing={1} direction="column">
                    <SectionTitle>{translate('experience_profile.price')}</SectionTitle>
                    {priceGroupId ? <PreviewPriceGroup id={priceGroupId} label="name" previewService={PreviewService} styles={{ fontSize: '16px', color: '#131313', whiteSpace: 'break-spaces' }} route={`/price-group/${priceGroupId}`} /> : <Text>{formatCurrency(price, currency, i18n.language)}</Text>}
                </Grid2>
            )}
            {/* Duration */}
            {Number.isFinite(duration) && (
                <Grid2 container size={6} spacing={1} direction="column">
                    <SectionTitle>{translate('experience_profile.duration')}</SectionTitle>
                    <Text>{TimeDurationFormatter(duration, translate)}</Text>
                </Grid2>
            )}
        </Grid2>
    );
};
